import { render, staticRenderFns } from "./TextPrivacyTermsTracking.vue?vue&type=template&id=39f20b32&scoped=true&"
import script from "./TextPrivacyTermsTracking.vue?vue&type=script&lang=js&"
export * from "./TextPrivacyTermsTracking.vue?vue&type=script&lang=js&"
import style0 from "./TextPrivacyTermsTracking.vue?vue&type=style&index=0&id=39f20b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f20b32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VRow})
